import { Box, Fade } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { Posts } from 'components/billboard'
import { Announcements } from 'components/dashboard'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as NivosPostOperations,
  operations as nivosPostOperations
} from 'states/dux/nivos-post/operations'
import { Payload as NivosPostPayload } from 'states/dux/nivos-post/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  nivosPost: NivosPostPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    nivosPost: NivosPostOperations
  }
}

type AppProps = StateProps & DispatchProps

const BillboardFC: React.FC<any> = (props: AppProps) => {
  return (
    <Fade in={true} timeout={1000}>
      <Box display={'flex'} flexDirection={'column'} width={'99%'}>
        <Announcements />

        <Posts />
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    nivosPost: state.nivosPost
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  nivosPost: nivosPostOperations
})

const Billboard = connect(mapStateToProps, mapDispatchToProps)(BillboardFC)

export default Billboard
